module.exports = __webpack_public_path__ + "img/icon_Renovation.6a75d8bd.svg";